import styled from "styled-components";

import { STYLES } from "@vita-learning/styles";

import type { InputStyledProps } from "./Input.d";

export const Input = styled.input<InputStyledProps>`
	background-color: ${({ readOnly }) => (readOnly ? STYLES.colors.lights.borders.light : "#FFF")};
	border: ${({ $error }) => `1px solid ${$error ? STYLES.colors.lights.backgrounds.dangers.normal : STYLES.colors.lights.borders.medium}`};
	border-radius: 0.25rem;
	cursor: ${({ readOnly }) => (readOnly ? "default" : "auto")};
	padding: 0.3rem 0.5rem;
	min-height: 38px; // same height as Select component

	&:focus,
	&:hover {
		border-width: 1px; 
		border-style: solid;
		border-color:	${({ readOnly, $error }) =>
			$error
				? STYLES.colors.lights.backgrounds.dangers.normal
				: STYLES.colors.lights.borders[readOnly ? "medium" : "dark"]};
	}

	@media screen and(${STYLES.breakpoints.desktop}) {
		border: 2px solid ${STYLES.colors.lights.borders.medium};
		border-radius: 0.5rem;
		padding: 0.6rem 1rem;
		min-height: 52px;
	}
`;
